import { useState } from 'react'
import { api, errorMessage } from '../lib/api'
import { useAuth } from '../lib/auth'
import { Banner, Button } from './ui'

/**
 * A login made with a temporary password (a new practice's first manager) chooses its
 * own before anything else. The server clears the flag when the password changes
 * (POST /dashboard/auth/my-password).
 */
export default function ChooseOwnPassword() {
  const { user, signOut, refresh } = useAuth()
  const [cur, setCur] = useState('')
  const [next, setNext] = useState('')
  const [again, setAgain] = useState('')
  const [err, setErr] = useState<string | null>(null)
  const [busy, setBusy] = useState(false)
  const INPUT = 'w-full rounded-md border border-slate-300 px-3 py-2 text-sm'
  async function save() {
    if (next !== again) { setErr('The two new passwords do not match.'); return }
    setBusy(true); setErr(null)
    try { await api.post('/auth/my-password', { currentPassword: cur, newPassword: next }); await refresh() }
    catch (e) { setErr(errorMessage(e)); setBusy(false) }
  }
  return (
    <div className="grid min-h-screen place-items-center bg-slate-50 px-4">
      <div className="w-full max-w-sm rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
        <h1 className="text-lg font-semibold text-slate-900">Choose your own password</h1>
        <p className="mt-1 text-sm text-slate-500">Welcome{user?.username ? `, ${user.username}` : ''}. You signed in with a temporary password; pick your own to carry on.</p>
        {err && <div className="mt-3"><Banner kind="error">{err}</Banner></div>}
        <div className="mt-4 space-y-3">
          <label className="block"><span className="mb-1 block text-xs font-medium text-slate-600">Temporary password</span>
            <input className={INPUT} type="password" autoComplete="current-password" value={cur} onChange={(e) => setCur(e.target.value)} /></label>
          <label className="block"><span className="mb-1 block text-xs font-medium text-slate-600">New password (at least 10 characters)</span>
            <input className={INPUT} type="password" autoComplete="new-password" value={next} onChange={(e) => setNext(e.target.value)} /></label>
          <label className="block"><span className="mb-1 block text-xs font-medium text-slate-600">New password again</span>
            <input className={INPUT} type="password" autoComplete="new-password" value={again} onChange={(e) => setAgain(e.target.value)} /></label>
          <Button className="w-full" disabled={busy || !cur || next.length < 10 || !again} onClick={save}>{busy ? 'Saving…' : 'Save and continue'}</Button>
          <button className="w-full text-center text-xs text-slate-500 underline" onClick={signOut}>Sign out</button>
        </div>
      </div>
    </div>
  )
}
